import { render, staticRenderFns } from "./RegistrationTax.vue?vue&type=template&id=2d526c00&scoped=true&"
import script from "./RegistrationTax.vue?vue&type=script&lang=js&"
export * from "./RegistrationTax.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationTax.vue?vue&type=style&index=0&id=2d526c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d526c00",
  null
  
)

export default component.exports